import { useStore } from "../../../app/stores/store";
import HeaderWrapper from "../../header/HeaderWrapper";
import CommissionSlipGrid from "./CommissionSlipGrid";
import Breadcrumb from "../../../app/common/common-components/Breadcrumb";

export default function CommissionSlipPage() {
  const {
    userStore: { userSession },
  } = useStore();

  document.title = "Base - CommissionSlip";

  return (
    <>
      <div className="container-fluid">
        <Breadcrumb breadcrumbs={[{ text: "Home", path: "/" }, { text: "Settings", path: "/settings" }, { text: "Commission Slip" }]} />
        <div className="row">
          <div className="hidden-sm col-md-2"></div>
          <div id="content" className="col-sm-12 col-md-12">
            <CommissionSlipGrid />
          </div>
          <div className="hidden-sm col-md-2"></div>
        </div>
      </div>
    </>
  );
}
